import { render, staticRenderFns } from "./Autoevaluacion.vue?vue&type=template&id=5011cf2f&"
import script from "./Autoevaluacion.vue?vue&type=script&lang=js&"
export * from "./Autoevaluacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports